export default [
  { name: 'id', label: 'ID', type: 'immutable' },
  { name: 'name', label: 'Name', type: 'immutable' },
  { name: 'active_for_global', label: 'Active for Global', type: 'boolean' },
  { name: 'active_for_user', label: 'Active for Me', type: 'boolean' }
]



// WEBPACK FOOTER //
// ./src/fields/features.js